import * as util from '../styles.util';
import {MxStyleObject, ServerStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';

export class TerminatorStyleKeeper implements StyleKeeper {
  constructor(
    private styles: ServerStyleObject,
    private terminatorObj: any
  ) {}

  public original() {
    return this.styles;
  }

  public mxCellCss() {
    const result = <MxStyleObject>{};

    result['shape'] = 'cross';
    result['strokeColor'] = 'none';
    result['cloneable'] = 0;
    result['whiteSpace'] = 'wrap';
    result['fontColor'] = this.styles.mainColor;
    result['editable'] = 0;
    result['rotatable'] = 0;
    result['resizable'] = 0;
    result['fillColor'] = 'transparent';
    result['fontSize'] = 13;
    result['fontStyle'] = 1;

    return util.objectToString(result, '=');
  }
}
